<!-- 注册隐私协议 -->
<template>
    <el-dialog :visible.sync="visible"
                v-if='visible'
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="40%">
  
      <!-- <template slot="title">
        {{ $t('agreement.title') }}
      </template> -->
      <body style="text-align:justify; overflow-y: auto;padding: 0px 14px 0 14px;widows:0; orphans:0;font-size: 12.5pt;background: #ffff; font-family:等线,sans-serif; ">
    <div>
        <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-weight: 600;"><span>跨境传输个人信息说明</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian"> 宝马中国/华晨宝马将向德国培训报表系统传输您的用户ID和培训记录。德国培训报表系统将生成培训汇总分析报告，以实现了解中国市场经销商人员培训的效果和质量，优化培训机制，促进人才发展。如您勾选“同意”选项，我们将通向其跨境传输您的上述个人信息。</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian; sans-serif">您可以通过tmsi.cq@bmwgroup.com，或通过宝马中国/华晨宝马联系德国宝马总部BMW AG以行使您对您个人信息的相关权利，您亦可向我们提出请求，我们将为您行使权利提供协助。</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian">有关我们处理您个人信息的完整内容，请参见《宝马个人信息保护政策》。</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:12.5pt"><span
                style="font-family:DengXian; -aw-import:ignore">&#xa0;</span></p>
    </div>
</body>
      <template slot="footer">
        <el-button type="button"
                   class="buttonqx"
                   :disabled="disabled"
                   @click="visible = false">同意</el-button>
      </template>
    </el-dialog>
  </template>
  <script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        visible: false,
        disabled: true
      }
    },
    methods: {
      init() {
        this.visible = true
        this.$nextTick(() => {
          this.getConfirm(0)
        })
      },
      getConfirm(time) {
        var _this = this
        if (time === 0) {
          this.disabled = false
          $('.buttonqx').html(this.$t('confirm'))
        } else {
          // 按钮不可用
          this.disabled = true
          $('.buttonqx').html(this.$t('agreement.confirm', { 'handle': time }))
          time--
          setTimeout(function () {
            _this.getConfirm(time)
          }, 1000)
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .el-input-number {
    width: 100% !important;
  }
  .el-input__inner {
    text-align: left !important;
  }
  .buttonqx {
    margin: 0px !important;
    width: 100%;
    // background-color: #1b69d4;
    color: #fff;
    border: 0px;
    line-height: 25px;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #666;
    background-color: #eee;
  }
  .el-button.el-button--default.is-disabled:hover {
    color: #666;
    background-color: #eee !important;
  }
  .el-button.el-button--default.is-disabled {
    color: #666;
    background-color: #eee !important;
  }
  .el-button.el-button--default {
    color: #fff;
    background-color: #5c9df5 !important;
    border-color: #5c9df5;
  }
  .buttomqr {
    margin-left: 0px !important;
    float: left !important;
    width: 100% !important;
    line-height: 23px;
  }
  .el-dialog__body div {
    // margin-top: 16px;
    line-height: 20px;
    overflow: auto;
    width: 100%;
    height: 30em;
  }
  .el-dialog__header {
      text-align: center;
      font-size: 18px;
  }
  .agree p{
      font-family: 等线, sans-serif;
  }
  .center{
    text-align:center;
  }
  .span2{
    padding-left:2em;
  }
  .span4{
    padding-left:4em;
  }
  .span6{
    padding-left:6em;
  }
  </style>
  